<div class="container container-shadow">
  <h3 class="pt-3">Document Template Roles</h3>
  <hr />
  <div class="row">
    <div class="col-md-6">
      <div class="text-center py-5 my-5" *ngIf="loading">
        <i class="fas fa-spinner fa-pulse fa-fw fa-4x"></i>
      </div>
      <div *ngIf="!loading">
        <div class="card">
          <div class="card-header">
            <a style="cursor: pointer" (click)="addingNewDocumentTemplateRoleName = !addingNewDocumentTemplateRoleName"><i class="fas" [ngClass]="{ 'fa-plus-circle': !addingNewDocumentTemplateRoleName, 'fa-minus-circle': addingNewDocumentTemplateRoleName }"></i> New Document Template Role</a>
          </div>
          <div class="card-body" *ngIf="addingNewDocumentTemplateRoleName">
            <div class="form-group">
              <input required type="text" class="form-control" [(ngModel)]="newDocumentTemplateRoleName.name" />
            </div>
            <div class="form-group text-center">
              <button type="button" (click)="saveDocumentTemplateRoleName(newDocumentTemplateRoleName)" [disabled]="savingDocumentTemplateRoleName" class="btn btn-primary">
                {{ savingDocumentTemplateRoleName ? 'Adding' : 'Add' }}<span *ngIf="savingDocumentTemplateRoleName">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
              &nbsp;
              <button type="button" [disabled]="savingDocumentTemplateRoleName" class="btn btn-secondary" (click)="addingNewDocumentTemplateRoleName = !addingNewDocumentTemplateRoleName">Cancel</button>
            </div>
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let documentTemplateRoleName of documentTemplateRoleNames">
              <td>{{ documentTemplateRoleName.id }}</td>
              <td *ngIf="!documentTemplateRoleName.editing">{{ documentTemplateRoleName.name }}</td>
              <td *ngIf="!documentTemplateRoleName.editing">
                <div class="btn-group btn-group-sm">
                  <button title="edit" [disabled]="deletingDocumentTemplateRoleName" type="button" class="btn btn-primary" (click)="documentTemplateRoleName.editing = true"><i class="fas fa-pencil-alt"></i></button>
                  <button title="delete" [disabled]="deletingDocumentTemplateRoleName" type="button" (click)="deleteDocumentTemplateRoleName(documentTemplateRoleName)" class="btn btn-danger"><i class="fas fa-trash"></i></button>
                </div>
                &nbsp;
                <span *ngIf="!selectedDocumentTemplateRoleName || selectedDocumentTemplateRoleName.id != documentTemplateRoleName.id">
                  <a style="cursor: pointer" (click)="selectDocumentTemplateRoleName(documentTemplateRoleName)">View Templates</a>
                </span>
                <span *ngIf="selectedDocumentTemplateRoleName && selectedDocumentTemplateRoleName.id == documentTemplateRoleName.id">
                  <strong>Templates <i class="fas fa-arrow-right"></i></strong>
                </span>
              </td>
              <td colspan="2" *ngIf="documentTemplateRoleName.editing">
                <div class="form-group">
                  <input required type="text" class="form-control" [(ngModel)]="documentTemplateRoleName.name" />
                </div>
                <div class="form-group text-center">
                  <button type="button" (click)="saveDocumentTemplateRoleName(documentTemplateRoleName)" [disabled]="savingDocumentTemplateRoleName" class="btn btn-primary">
                    {{ savingDocumentTemplateRoleName ? 'Saving' : 'Save' }}<span *ngIf="savingDocumentTemplateRoleName">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                  </button>
                  &nbsp;
                  <button type="button" [disabled]="savingDocumentTemplateRoleName" class="btn btn-secondary" (click)="documentTemplateRoleName.editing = !documentTemplateRoleName.editing">Cancel</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-6" *ngIf="selectedDocumentTemplateRoleName">
      <h5 class="pt-2">
        Templates for <span class="text-success">{{ selectedDocumentTemplateRoleName.name }}</span>
      </h5>
      <div class="text-center py-5 my-5" *ngIf="loadingTemplates">
        <i class="fas fa-spinner fa-pulse fa-fw fa-4x"></i>
      </div>
      <div *ngIf="!loadingTemplates">
        <div class="card">
          <div class="card-header">
            <a style="cursor: pointer" (click)="addingNewDocumentTemplateRole = !addingNewDocumentTemplateRole"><i class="fas" [ngClass]="{ 'fa-plus-circle': !addingNewDocumentTemplateRole, 'fa-minus-circle': addingNewDocumentTemplateRole }"></i> Add Template to Role</a>
          </div>
          <div class="card-body" *ngIf="addingNewDocumentTemplateRole">
            <div class="form-group">
              <app-doc-template-search (docTemplateSelection)="selectDocTemplate($event)"></app-doc-template-search>
            </div>
            <div class="form-group text-center">
              <button type="button" (click)="saveDocumentTemplateRole(newDocumentTemplateRole)" [disabled]="savingDocumentTemplateRole" class="btn btn-primary">
                {{ savingDocumentTemplateRole ? 'Adding' : 'Add' }}<span *ngIf="savingDocumentTemplateRole">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
              &nbsp;
              <button type="button" [disabled]="savingDocumentTemplateRole" class="btn btn-secondary" (click)="addingNewDocumentTemplateRole = !addingNewDocumentTemplateRole">Cancel</button>
            </div>
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Template</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let documentTemplateRole of documentTemplateRoles">
              <td>{{ documentTemplateRole.id }}</td>
              <td>
                <a target="_blank" [href]="documentTemplateRole.template_class == 'DocumentTemplate' ? '/doc_templates/new?document_template_id=' + documentTemplateRole.document_template_id : '/doc_templates/' + documentTemplateRole.document_template_id + '/edit?template=doctemplate'">
                  {{ documentTemplateRole.template_name }} ({{ documentTemplateRole.template_class == 'DocumentTemplate' ? 'v1' : 'v5' }})
                </a>
              </td>
              <td>
                <div class="btn-group btn-group-sm">
                  <button title="delete" [disabled]="deletingDocumentTemplateRole" type="button" (click)="deleteDocumentTemplateRole(documentTemplateRole)" class="btn btn-danger"><i class="fas fa-times"></i></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
